import React, { Component } from 'react';
import Formulario from './NuevoRegistroSanitarioForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class RegistroSanitario extends Component{
    state = {
        crear: true,
        documento: null,
        productoPais: ''
    }

    componentDidMount = () => {
        const { match, leer, getModulo, getPais, listarLicencias, listarVias,
            listarAcondicionadores, listarFabricante, listarProductos,
            listarClasificacion, listarPaisesOrigen, parametrosEmpresa,
            listarTiposRegistro, limpiarDatos } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
            listarProductos();
            listarFabricante();
            listarAcondicionadores();
            listarClasificacion();
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        getPais(modulo[7]);
        listarVias();
        listarPaisesOrigen();
        listarLicencias();
        listarTiposRegistro();
        limpiarDatos();
        parametrosEmpresa();
    }
    
    setConstancia = (documento) => {
        this.setState({documento});
    };

    setProductoPais = (productoPais) => {
        this.setState({ productoPais });
    }

    registroRS = (data) => {
        const { registroRS } = this.props;
        registroRS( {...data, documento: null},
            [{ "file": this.state.documento, "name": 'constancia' }],
            this.state.productoPais
        )
    }

    modificarRS = (data) => {
        const { modificarRS } = this.props;
        modificarRS( {...data, documento: null},
        [{ "file": this.state.documento, "name": 'constancia' }])
    }

    render(){
        const {loader, modulo, listaPro, paisN, listaELZM,
            listaAcond, listaClasificacion, lectura, listaFab,
            listaCom, listaPaisOrigen, listaVia, lic, tipoRegistro,
            codigoPais, datoRegistro, listRegistroProducto, descripcionProducto,
            buscarProductos, buscarFabricante, buscarAcondicionador,
            buscarClasificacion, registroProducto, datos, codigo_unificacion } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    obtenerProductos = {listaPro}
                    obtenerFabricantes = {listaFab}
                    obtenerAcondicionadores = {listaAcond}
                    obtenerClasificacion = {listaClasificacion}
                    lectura = {lectura}
                    registroRS = {this.registroRS}
                    modificarRS = {this.modificarRS}
                    paisN = {paisN}
                    obtenerComercializador = {listaCom}
                    obtenerPaises = {listaPaisOrigen}
                    obtenerLicencias = {lic}
                    obtenerVias = {listaVia}
                    obtenerTipoRegistro = {tipoRegistro}
                    codigoPais = {codigoPais}
                    datoRegistro = {datoRegistro}
                    listRegistroProducto = {listRegistroProducto}
                    descripcionProducto = {descripcionProducto}
                    buscarProductos = {buscarProductos}
                    buscarFabricante = {buscarFabricante}
                    buscarAcondicionador = {buscarAcondicionador}
                    buscarClasificacion = {buscarClasificacion}
                    registroProducto = {registroProducto}
                    datos = {datos}
                    setConstancia = {this.setConstancia}
                    setProductoPais = {this.setProductoPais}
                    codigo_unificacion = {codigo_unificacion}
                    listaELZM = {listaELZM}
                />
            </LoadMask>
        );
    }
}


export default RegistroSanitario;
